export const es = {
  nav: {
    home: "Inicio",
    about: "Nosotros",
    services: "Servicios",
    resources: "Recursos",
    blog: "Blog",
    faq: "Preguntas",
    contact: "Contacto",
    book: "Reserva tu Cita",
    menu: "Menú",
    close: "Cerrar",
  },
  common: {
    chapter: "Capítulo",
    learnMore: "Conocer este servicio",
    readArticle: "Leer artículo",
    viewAll: "Ver todo",
    minRead: "min de lectura",
    draft: "Borrador editorial",
    published: "Publicado",
    updated: "Actualizado",
    reviewed: "Revisado",
    by: "Por",
    related: "Lectura relacionada",
    toc: "En este artículo",
    backToBlog: "Volver a Aviah Insights",
    disclaimerTitle: "Importante",
    skip: "Saltar al contenido",
  },
  footer: {
    statement: ["PROTEGE LO QUE IMPORTA.", "HAZ CRECER LO POSIBLE.", "CONSTRUYE LO QUE PERDURA."],
    company: "Compañía",
    services: "Servicios",
    resources: "Recursos",
    legal: "Legal",
    contact: "Contacto",
    about: "Nosotros",
    founder: "Fundadora",
    blog: "Blog",
    faq: "Preguntas",
    privacy: "Política de Privacidad",
    terms: "Términos de Uso",
    disclosures: "Divulgaciones",
    accessibility: "Accesibilidad",
    editorial: "Política Editorial",
    bookCta: "Reserva tu Cita",
    appointment: "Con cita previa",
    rights: "Todos los derechos reservados.",
    poweredBy: "Desarrollado por",
    miniDisclaimer:
      "El contenido de este sitio web es información educativa general y no constituye asesoría fiscal, legal, contable ni de inversión. Enviar un formulario no establece una relación profesional.",
  },
  home: {
    seo: {
      title: "Aviah Financial — Consultoría Financiera y Empresarial | Lake Nona, Orlando",
      description:
        "Consultoría financiera y empresarial integrada en Lake Nona, Orlando. Consultoría empresarial, consultoría financiera, protección de activos, planificación patrimonial e inversiones estratégicas. English & Español.",
    },
    hero: {
      eyebrow: "Consultoría Financiera y Empresarial • Orlando, Florida",
      lines: ["CLARIDAD PARA HOY.", "ESTRATEGIA PARA MAÑANA.", "UN LEGADO PARA LO QUE VIENE."],
      body: "Aviah Financial reúne orientación financiera, empresarial y estratégica bajo una misma relación de confianza para ayudar a individuos, familias, emprendedores y empresas a comprender sus opciones, proteger lo que han construido y avanzar con mayor seguridad.",
      primary: "Reserva tu Cita",
      secondary: "Conoce Nuestros Servicios",
      micro: ["Lake Nona • Orlando, Florida", "Consultas presenciales y virtuales", "Se requiere cita"],
      scroll: "Desliza",
    },
    marquee: ["Claridad", "Estrategia", "Legado", "Precisión", "Discreción", "Lake Nona — Orlando"],
    trust: {
      eyebrow: "Experiencia. Credenciales. Responsabilidad.",
      title: "Una práctica construida sobre trabajo verificable.",
    },
    numbers: {
      chapter: "Más Que Números",
      title: "Cada decisión financiera lleva una historia humana.",
      p1: "Detrás de cada decisión de impuestos, negocio en crecimiento, activo familiar, meta financiera o inversión futura hay algo profundamente personal: años de trabajo, sacrificio, familia, ambición, seguridad y legado.",
      p2: "Aviah Financial nació de la convicción de que la orientación financiera no debe dejar a las personas confundidas ni intimidadas. Debe crear claridad. Debe educar. Debe ayudar a tomar decisiones informadas con confianza.",
      quote: "El futuro pertenece a quienes lo planifican.",
    },
    strategy: {
      chapter: "La Visión Integrada",
      title: "Una perspectiva. Múltiples dimensiones de tu vida financiera.",
      copy: "Las decisiones financieras importantes están conectadas entre sí. Selecciona cualquier dimensión para ver cómo se relaciona con el resto de tu panorama.",
      hub: ["Tú", "Tu Familia", "Tu Negocio", "Tu Legado"],
      hint: "Toca una dimensión para ver sus conexiones.",
      relations: {
        tax: ["Contabilidad", "Negocio", "Legado"],
        accounting: ["Impuestos", "Negocio"],
        assets: ["Patrimonio", "Legado", "Negocio"],
        estate: ["Activos", "Legado", "Familia"],
        business: ["Impuestos", "Activos", "Patrimonio", "Legado"],
        investments: ["Activos", "Legado"],
        legacy: ["Activos", "Patrimonio", "Familia"],
      },
    },
    services: {
      chapter: "Explora Nuestros Servicios",
      title: "Cinco áreas. Una perspectiva financiera integrada.",
      copy: "Cada área se maneja como parte de un panorama completo — nunca como una transacción aislada.",
    },
    founder: {
      chapter: "Fundadora y CEO",
      title: "Construido con experiencia. Definido por el liderazgo.",
      titleLines: ["Construido con experiencia.", "Definido por el liderazgo."],
      p1: "Mucho antes de que Aviah Financial se convirtiera en una empresa, sus cimientos se estaban construyendo a través de años de experiencia en servicios financieros, administración, operaciones, liderazgo y negocios.",
      p2: "Cada etapa fortaleció una capacidad distinta — desde comprender las decisiones financieras y las necesidades de los clientes hasta desarrollar disciplina organizacional, gestionar entornos complejos y construir una perspectiva empresarial más amplia.",
      p3: "Hoy, esas experiencias convergen en un solo enfoque integrado: claridad antes que complejidad, estrategia antes que incertidumbre, y propósito detrás de cada decisión.",
      bioP1: "Escarling Martínez comenzó su trayectoria profesional a los 18 años en la industria de seguros con MetLife, y luego construyó experiencia en operaciones corporativas en TJX Companies en Boston, administración en el Departamento de Emergencias de Mass General Hospital, y una licenciatura en Contabilidad y Administración de Empresas.",
      bioP2: "Esa base combinada — servicios financieros, operaciones corporativas, administración hospitalaria, liderazgo y contabilidad — se convirtió en el terreno sobre el cual se construyó Aviah Financial.",
      cta: "Conoce a la fundadora",
      stages: [
        { lines: ["Fundamento", "Financiero"], micro: "Inicio profesional", d: "La experiencia profesional temprana construyó una base en servicios financieros, relaciones con clientes y toma de decisiones informada." },
        { lines: ["Disciplina", "Operativa"], d: "La experiencia en operaciones corporativas fortaleció la organización, la administración, la gestión de procesos y la disciplina empresarial." },
        { lines: ["Liderazgo"], d: "La creciente responsabilidad profesional desarrolló un liderazgo más sólido, la comunicación, la toma de decisiones y la capacidad de gestionar entornos complejos." },
        { lines: ["Visión", "Empresarial"], d: "La exposición a la administración de empresas y las operaciones internacionales amplió la capacidad de entender las organizaciones más allá de una sola decisión financiera." },
        { lines: ["Precisión", "Bajo Presión"], d: "Trabajar en entornos profesionales exigentes fortaleció la disciplina, la atención al detalle, la comunicación y la capacidad de tomar decisiones cuidadosas bajo presión." },
        { lines: ["Contabilidad", "+ Negocios"], d: "La educación formal en Contabilidad y Administración de Empresas conectó la experiencia práctica con una base financiera y organizacional más sólida." },
        { lines: ["Estrategia", "Integrada"], d: "Años de experiencia financiera, operativa, administrativa y de liderazgo convergieron en una visión más completa de cómo individuos, familias y empresas deben abordar las decisiones importantes." },
        { lines: ["Aviah", "Financial"], d: "Una firma de consultoría financiera y empresarial construida alrededor de una convicción: las decisiones importantes nunca deben tomarse de forma aislada." },
      ],
      finale: {
        lines: ["Cada experiencia", "construyó hacia un", "camino más claro."],
        tagline: ["Protege lo que importa.", "Haz crecer lo posible.", "Construye lo que perdura."],
      },
    },
    mission: {
      chapter: "Misión y Visión",
      missionLabel: "Misión",
      missionWords: "Educar. Elevar. Empoderar.",
      missionCopy:
        "Llevar claridad a la complejidad y estrategia a cada decisión — ayudando a los clientes a comprender sus opciones, proteger lo que han construido, perseguir lo que es posible y avanzar con mayor confianza.",
      visionLabel: "Visión",
      visionCopy:
        "Una nueva era de consultoría financiera y empresarial donde la estrategia es inteligente, la protección es intencional y el legado está construido para perdurar.",
      line: "El futuro pertenece a quienes lo planifican.",
    },
    serve: {
      chapter: "A Quién Servimos",
      title: "La estrategia debe adaptarse a la persona. No al revés.",
      items: [
        { t: "Individuos", d: "Finanzas personales organizadas con claridad y cuidado." },
        { t: "Familias", d: "Protección y planificación a través de generaciones." },
        { t: "Emprendedores", d: "Estructura y orientación desde la primera decisión." },
        { t: "Pequeños Negocios", d: "Apoyo en organización, administración y crecimiento." },
        { t: "Empresas", d: "Estrategia financiera y administrativa coordinada." },
        { t: "Inversionistas", d: "Evaluación alineada con objetivos a largo plazo." },
      ],
    },
    method: {
      chapter: "El Método Aviah",
      title: "Primero tu situación. Después la estrategia.",
      steps: [
        { n: "01", t: "Escuchar", d: "Comenzamos por comprender tu situación actual, necesidades, prioridades y metas." },
        { n: "02", t: "Analizar", d: "Revisamos la información e identificamos las áreas que requieren atención." },
        { n: "03", t: "Construir la Estrategia", d: "Determinamos qué servicios o estrategias pueden aportar valor y explicamos el proceso, la documentación y los próximos pasos." },
        { n: "04", t: "Avanzar Juntos", d: "Mantenemos una comunicación clara durante todo el proceso." },
      ],
    },
    privacy: {
      title: "Tu información merece la misma protección que tu futuro.",
      copy: "La privacidad, la discreción y la confianza son principios fundamentales en la relación de Aviah Financial con cada cliente. La información se maneja de forma profesional y discreta, con énfasis en la confidencialidad y la comunicación transparente.",
      pillars: [
        { t: "Privacidad", d: "La discreción no es una cortesía. Es el estándar." },
        { t: "Transparencia", d: "Comprendes el proceso en cada paso." },
        { t: "Precisión", d: "Las decisiones importantes merecen atención cuidadosa." },
      ],
    },
    why: {
      chapter: "Por Qué Aviah",
      title: "Por qué los clientes eligen un enfoque integrado.",
      items: [
        { n: "01", t: "El Panorama Completo", d: "Las decisiones importantes están interconectadas — y así las tratamos." },
        { n: "02", t: "Estrategia Personalizada", d: "Las recomendaciones comienzan con tus circunstancias, no con una plantilla." },
        { n: "03", t: "Comunicación Clara", d: "Temas complejos explicados en un lenguaje que puedes entender." },
        { n: "04", t: "Privacidad y Discreción", d: "La confidencialidad y la confianza son fundamentales en cada relación." },
        { n: "05", t: "Experiencia, Credenciales y Responsabilidad", d: "La experiencia profesional, los procesos disciplinados y la responsabilidad guían cada compromiso." },
      ],
    },
    location: {
      chapter: "Lake Nona, Orlando",
      title: "Orientación profesional, aquí mismo en Lake Nona.",
      features: [
        "Lake Nona, sureste de Orlando",
        "A minutos del Aeropuerto Internacional de Orlando (MCO)",
        "Estacionamiento gratuito",
        "Consultas presenciales",
        "Consultas virtuales",
        "Se requiere cita",
      ],
      directions: "Cómo Llegar",
      book: "Reserva tu Consulta",
      hoursLabel: "Horario de oficina",
    },
    insights: {
      chapter: "Aviah Insights",
      title: "Educación financiera, escrita para entenderse.",
      copy: "Orientación editorial sobre impuestos, negocios, protección y legado — en inglés y español.",
      cta: "Visita Aviah Insights",
    },
    final: {
      title: "Reserva tu cita hoy. Estamos aquí para servirte.",
      copy: "Ya sea que estés organizando tus finanzas, haciendo crecer un negocio, protegiendo lo que has construido o planificando lo que viene — el primer paso es comprender tus opciones.",
      cta: "Reserva tu Consulta",
      or: "O llama al",
    },
  },
  about: {
    seo: {
      title: "Nosotros — Aviah Financial | Orientación financiera con un punto de vista humano",
      description:
        "La historia de Aviah Financial y de su fundadora Escarling Martínez — una trayectoria por seguros, operaciones corporativas, administración hospitalaria y contabilidad, convertida en una práctica de consultoría integrada en Lake Nona, Orlando.",
    },
    eyebrow: "Sobre Aviah Financial",
    title: "Orientación financiera con un punto de vista humano.",
    intro:
      "Aviah Financial es una práctica de consultoría financiera y empresarial en Lake Nona, Orlando — creada para reunir en un solo lugar la orientación que las personas suelen tener que buscar entre múltiples profesionales.",
    origin: {
      chapter: "Por Qué Existe Aviah",
      title: "Las decisiones importantes nunca deben tomarse de forma aislada.",
      p1: "Con los años, nuestra fundadora observó el mismo patrón: individuos, familias, emprendedores y empresas necesitaban ayuda en múltiples áreas de su vida financiera y empresarial — pero tenían que acudir a un profesional distinto para cada necesidad, y las piezas rara vez se comunicaban entre sí.",
      p2: "Aviah Financial fue creada para ofrecer un enfoque más integrado: un espacio donde individuos, familias, emprendedores, pequeños negocios, empresas e inversionistas pueden acceder a una orientación que comienza con su situación completa — no con un problema aislado.",
    },
    founderTitle: "La fundadora",
    values: {
      chapter: "Nuestros Valores",
      title: "Siete principios que guían cada compromiso.",
      items: [
        { t: "Integridad Sobre Interés", d: "Cada recomendación se formula con el mejor interés del cliente como prioridad." },
        { t: "Precisión Sobre Velocidad", d: "Las decisiones importantes se abordan con cuidado y exactitud — nunca con prisa." },
        { t: "Discreción Como Estándar", d: "La privacidad no es una cortesía adicional. Es una expectativa esencial." },
        { t: "Educación", d: "Debes comprender el proceso y las decisiones que se están considerando." },
        { t: "Transparencia", d: "Los procesos, servicios y recomendaciones se comunican con claridad." },
        { t: "Estrategia Personalizada", d: "Cada persona, familia y empresa tiene metas y circunstancias diferentes." },
        { t: "Resultados", d: "Nos enfocamos en un progreso significativo, resultados prácticos y soluciones alineadas con tus metas." },
      ],
    },
    office: {
      chapter: "La Oficina",
      title: "Lake Nona, Orlando.",
      copy: "Una oficina profesional en uno de los distritos más visionarios de Orlando — a minutos del Aeropuerto Internacional de Orlando, con consultas presenciales y virtuales, con cita previa.",
    },
  },
  servicesPage: {
    seo: {
      title: "Servicios — Consultoría Empresarial, Financiera, Protección de Activos, Patrimonio e Inversiones | Aviah Financial",
      description:
        "Cinco áreas de servicio integradas: consultoría empresarial, consultoría financiera, protección de activos, planificación patrimonial e inversiones estratégicas. Lake Nona, Orlando. English & Español.",
    },
    eyebrow: "Servicios",
    title: "Orientación integrada para tu vida financiera.",
    copy: "Cinco áreas, coordinadas a través de una sola relación — para que cada decisión se tome con el panorama completo a la vista.",
  },
  resourcesPage: {
    seo: {
      title: "Recursos — Centro de Educación Financiera | Aviah Financial",
      description:
        "Listas de verificación, guías y educación financiera de Aviah Financial. Educación primero — sin pedir tu correo. Lake Nona, Orlando.",
    },
    eyebrow: "Recursos",
    title: "Un centro de educación financiera, abierto a todos.",
    copy: "Listas de verificación y guías prácticas que puedes usar hoy. La educación va primero — nada aquí se esconde detrás de un formulario.",
    checklistTitle: "Listas de verificación",
    checklists: [
      {
        t: "Lista para la preparación de impuestos",
        items: [
          "Declaración de impuestos del año anterior, si está disponible",
          "Formularios W-2, 1099 y otros comprobantes de ingresos",
          "Identificación de cada declarante y dependiente",
          "Registros de gastos deducibles",
          "Registros de ingresos y gastos del negocio, si aplica",
          "Documentación de ITIN o Seguro Social, cuando corresponda",
        ],
      },
      {
        t: "Lista de organización empresarial",
        items: [
          "Estructura del negocio elegida y documentada",
          "EIN y registros estatales en orden",
          "Cuenta bancaria comercial separada",
          "Rutina básica de contabilidad establecida",
          "Enfoque de nómina definido, si tienes empleados",
          "Calendario anual de presentaciones anotado",
        ],
      },
      {
        t: "Antes de tu primera consulta",
        items: [
          "Una lista breve de tus metas e inquietudes",
          "Cualquier aviso o carta que quieras revisar",
          "Estados financieros recientes, si los tienes",
          "Preguntas — escritas, en cualquier orden",
        ],
      },
    ],
    note: "No envíes documentos sensibles (SSN, números completos de ITIN, estados bancarios, documentos fiscales) a través del sitio web. Tráelos a tu consulta.",
    ctaTitle: "¿Quieres una guía hecha a tu medida?",
    ctaCopy: "La lista más útil es la que se construye alrededor de tus circunstancias reales.",
  },
  blogPage: {
    seo: {
      title: "Aviah Insights — Educación Financiera en Español e Inglés",
      description:
        "Aviah Insights: educación financiera editorial sobre impuestos, negocios, protección de activos, planificación patrimonial e inversiones — escrita para entenderse. Lake Nona, Orlando.",
    },
    eyebrow: "Aviah Insights",
    title: "Ideas que te ayudan a decidir.",
    copy: "Educación financiera editorial — sin titulares exagerados, sin promesas, solo claridad.",
    all: "Todos",
  },
  faqPage: {
    seo: {
      title: "Preguntas Frecuentes — Aviah Financial | Lake Nona, Orlando",
      description:
        "Respuestas a las preguntas más comunes sobre Aviah Financial: servicios, consultas, ubicación, apoyo bilingüe y cómo funciona la primera cita.",
    },
    eyebrow: "Preguntas Frecuentes",
    title: "Todo lo que vale la pena preguntar antes de conocernos.",
    items: [
      { q: "¿Qué hace Aviah Financial?", a: "Aviah Financial es una práctica de consultoría financiera y empresarial. Reunimos cinco áreas — consultoría empresarial, consultoría financiera, protección de activos, planificación patrimonial e inversiones estratégicas — bajo una sola relación integrada, para que tus decisiones se tomen con el panorama completo a la vista." },
      { q: "¿A quién sirve Aviah Financial?", a: "A individuos, familias, emprendedores, pequeños negocios, empresas e inversionistas — principalmente en Orlando y Lake Nona, con consultas virtuales disponibles donde sea legalmente apropiado." },
      { q: "¿Trabajan tanto con individuos como con empresas?", a: "Sí. Muchos de nuestros clientes son ambas cosas: dueños de negocio cuyas finanzas personales y empresariales deben considerarse juntas. Esa intersección es exactamente donde un enfoque integrado aporta más valor." },
      { q: "¿Ofrecen consultas virtuales?", a: "Sí. Las consultas están disponibles en persona en nuestra oficina de Lake Nona y de forma virtual, donde sea legalmente apropiado." },
      { q: "¿Puedo visitar la oficina?", a: "Sí — con cita previa. Nuestra oficina está en 6900 Tavistock Lakes Blvd, Suite 400, Orlando, FL 32827, en Lake Nona, con estacionamiento gratuito." },
      { q: "¿Dónde está ubicada Aviah Financial?", a: "En Lake Nona, sureste de Orlando — 6900 Tavistock Lakes Blvd, Suite 400, Orlando, FL 32827, a minutos del Aeropuerto Internacional de Orlando (MCO)." },
      { q: "¿Se requiere cita?", a: "Sí. Cada relación con un cliente comienza con una consulta programada, para poder dedicar tiempo ininterrumpido a tu situación." },
      { q: "¿Cómo funciona la primera consulta?", a: "Primero escuchamos. Revisamos tu situación actual, necesidades, prioridades y metas; luego explicamos qué áreas pueden merecer atención, cómo es el proceso y qué documentación se necesitaría. Te vas con claridad — no con presión." },
      { q: "¿Cómo sé qué servicio necesito?", a: "No tienes que saberlo. La mayoría de las situaciones tocan más de un área, y por eso la primera conversación mira el panorama completo antes de recomendar cualquier cosa." },
      { q: "¿Ofrecen asistencia bilingüe?", a: "Sí. El servicio completo está disponible en inglés y español — consultas, revisión de documentos y comunicación continua." },
      { q: "¿Qué información debo llevar a mi primera consulta?", a: "Una lista breve de tus metas e inquietudes, cualquier aviso o carta que quieras revisar y estados financieros recientes si están disponibles. Nunca envíes documentos sensibles — SSN, números completos de ITIN, documentos bancarios o fiscales — a través del sitio web; tráelos a tu consulta." },
      { q: "¿Se pueden coordinar varios servicios juntos?", a: "Sí — esa coordinación es precisamente el punto. Las decisiones de impuestos afectan la estructura del negocio; las decisiones del negocio afectan el plan patrimonial. Evaluamos las relaciones entre áreas antes de recomendar cualquier paso." },
    ],
  },
  contactPage: {
    seo: {
      title: "Contacto — Reserva tu Cita | Aviah Financial, Lake Nona",
      description:
        "Solicita una consulta con Aviah Financial en Lake Nona, Orlando. Citas presenciales y virtuales. Llama al (407) 340-9141. English & Español.",
    },
    eyebrow: "Contacto",
    title: "Hablemos de lo que viene.",
    copy: "Cuéntanos un poco sobre tu situación y confirmaremos tu consulta. Cada solicitud se revisa personalmente.",
    form: {
      name: "Nombre completo",
      phone: "Teléfono",
      email: "Correo electrónico",
      preferredContact: "Método de contacto preferido",
      contactOptions: { phone: "Teléfono", email: "Correo", text: "Mensaje de texto" },
      service: "Servicio de tu interés",
      services: {
        "business-consulting": "Consultoría Empresarial",
        "tax-accounting": "Consultoría Financiera",
        "asset-protection": "Protección de Activos",
        "estate-planning": "Planificación Patrimonial",
        "strategic-investments": "Inversiones Estratégicas",
        other: "Otro / Aún no lo sé",
      },
      type: "Tipo de consulta",
      typeOptions: { "in-person": "Presencial — oficina de Lake Nona", virtual: "Virtual" },
      date: "Fecha preferida",
      time: "Hora preferida",
      message: "¿Cómo podemos ayudarte?",
      messagePlaceholder: "Unas pocas frases son suficientes. Por favor no incluyas números de Seguro Social, números completos de ITIN, números de cuenta ni documentos fiscales.",
      consent:
        "Entiendo que enviar este formulario no establece una relación profesional, legal, fiscal, contable ni de asesoría de inversión.",
      submit: "Solicitar Consulta",
      sending: "Enviando…",
      successTitle: "Solicitud recibida.",
      successCopy:
        "Gracias por escribirnos. Tu solicitud de consulta ha sido recibida y será revisada personalmente. Te contactaremos por tu método preferido para confirmar tu cita.",
      errorCopy: "Algo salió mal. Inténtalo de nuevo o llámanos al (407) 340-9141.",
      sensitiveError: "Para tu protección, no incluyas números de Seguro Social ni identificaciones completas en este formulario.",
      required: "Este campo es obligatorio.",
    },
    aside: {
      title: "La oficina",
      hoursTitle: "Horario de oficina",
      note: "Las consultas son con cita previa, presenciales o virtuales.",
      neverTitle: "Lo que este formulario nunca pide",
      neverCopy: "Números de Seguro Social, números completos de ITIN, números de cuentas bancarias, copias de pasaportes ni documentos fiscales. Si tu caso requiere intercambio seguro de documentos, se realiza a través de un proceso separado y protegido después de tu consulta.",
    },
  },
  legal: {
    updated: "Última actualización: julio de 2026",
    privacy: {
      title: "Política de Privacidad",
      sections: [
        { h: "Nuestro compromiso", p: ["La privacidad y la discreción son principios fundamentales en Aviah Financial. Esta política explica qué información recopila este sitio web, por qué y cómo se maneja."] },
        { h: "Qué recopilamos", p: ["Si envías el formulario de consulta, recibimos los datos que proporcionas: nombre, teléfono, correo, método de contacto preferido, servicio de interés, preferencia de consulta y tu mensaje.", "No pedimos — y te pedimos que nunca envíes — números de Seguro Social, números completos de ITIN, números de cuentas bancarias, copias de pasaportes, documentos fiscales ni estados financieros a través de este sitio web."] },
        { h: "Cómo se usa la información", p: ["La información que envías se utiliza únicamente para responder a tu solicitud, programar y preparar tu consulta, y comunicarnos contigo al respecto.", "No vendemos tu información. No la compartimos con terceros excepto cuando es necesario para operar el sitio (por ejemplo, nuestro proveedor de correo) o cuando lo exige la ley."] },
        { h: "Almacenamiento y seguridad", p: ["Las solicitudes de consulta se almacenan en una base de datos protegida. El sitio se sirve por HTTPS y los formularios usan validación en el servidor, límites de frecuencia y protección contra bots.", "Ningún método de transmisión por internet es 100% seguro; te recomendamos compartir documentos sensibles solo por los canales protegidos que se establecen después de tu consulta."] },
        { h: "Tus opciones", p: ["Puedes solicitar que corrijamos o eliminemos la información que enviaste llamándonos al (407) 340-9141."] },
        { h: "Cambios", p: ["Esta política puede actualizarse a medida que el sitio evoluciona. La versión vigente siempre está disponible en esta página. El texto legal final se revisa con asesoría legal calificada antes del lanzamiento."] },
      ],
    },
    terms: {
      title: "Términos de Uso",
      sections: [
        { h: "Aceptación", p: ["Al usar este sitio web aceptas estos términos. Si no estás de acuerdo, por favor no utilices el sitio."] },
        { h: "Contenido únicamente educativo", p: ["Todo el contenido de este sitio web es información educativa general. No es asesoría fiscal, legal, contable ni de inversión, y no considera tus circunstancias individuales.", "Enviar un formulario, mandar un mensaje o leer el contenido de este sitio no establece una relación profesional, legal, fiscal, contable ni de asesoría de inversión con Aviah Financial."] },
        { h: "Sin garantías", p: ["No ofrecemos garantías sobre resultados, reembolsos, rendimientos ni resultados de ningún tipo. Las circunstancias individuales varían."] },
        { h: "Uso aceptable", p: ["Aceptas no hacer un uso indebido de este sitio, no intentar interrumpir su funcionamiento y no enviar información falsa, engañosa o dañina a través de sus formularios."] },
        { h: "Propiedad intelectual", p: ["El nombre Aviah, su logotipo y el contenido del sitio son propiedad de Aviah Financial y no pueden reproducirse sin permiso por escrito."] },
        { h: "Revisión", p: ["Estos términos se revisan con asesoría legal calificada antes del lanzamiento y pueden actualizarse; la versión vigente siempre se publica aquí."] },
      ],
    },
    accessibility: {
      title: "Declaración de Accesibilidad",
      sections: [
        { h: "Nuestro compromiso", p: ["Aviah Financial se compromete a un sitio web utilizable por todas las personas, incluidas las personas con discapacidad. Nuestro objetivo es la conformidad WCAG 2.2 Nivel AA."] },
        { h: "Medidas que tomamos", p: ["HTML semántico y jerarquía lógica de encabezados.", "Navegación por teclado y estados de enfoque visibles.", "Etiquetas de formulario y descripciones de error.", "Combinaciones de color con contraste adecuado.", "Compatibilidad con preferencias de movimiento reducido."] },
        { h: "Comentarios", p: ["Si encuentras una barrera de accesibilidad, llámanos al (407) 340-9141 y te proporcionaremos la información en un formato alternativo y atenderemos el problema."] },
      ],
    },
    editorial: {
      title: "Política Editorial",
      sections: [
        { h: "Propósito", p: ["Aviah Insights existe para educar. Los artículos explican conceptos, procesos y preguntas — no venden resultados."] },
        { h: "Estándares", p: ["Sin titulares exagerados, sin resultados garantizados, sin consejos individualizados presentados como universales.", "Los artículos son escritos o revisados por los profesionales nombrados como autores, se publican de forma bilingüe y llevan fechas de publicación, actualización y revisión."] },
        { h: "Correcciones", p: ["Si se identifica un error, lo corregimos y actualizamos la fecha de revisión del artículo. Para reportar una inquietud, llama al (407) 340-9141."] },
      ],
    },
    disclosures: {
      title: "Divulgaciones",
      sections: [
        { h: "General", p: ["El contenido de este sitio web es información educativa general y no constituye asesoría fiscal, legal, contable, de inversión ni asesoría legal migratoria. Las circunstancias individuales varían; consulta a un profesional calificado sobre tu situación."] },
        { h: "Impuestos", p: ["La información fiscal presentada es de carácter general. No se garantiza ningún resultado, monto de reembolso ni resultado fiscal."] },
        { h: "Inversiones", p: ["Nada en este sitio web constituye una oferta, solicitud o recomendación de ningún valor o producto de inversión. Toda inversión implica riesgo, incluida la posible pérdida del capital. No se garantiza ningún rendimiento."] },
        { h: "Asuntos legales y patrimoniales", p: ["Aviah Financial no es un bufete de abogados. Cuando los documentos o servicios legales requieren un abogado, trabajamos junto a profesionales legales calificados e independientes."] },
      ],
    },
  },
  authorPage: {
    seo: {
      title: "Escarling Martínez — Fundadora y CEO | Aviah Financial",
      description:
        "Escarling Martínez, Fundadora y CEO de Aviah Financial — una trayectoria profesional por seguros, operaciones corporativas, administración hospitalaria y contabilidad.",
    },
    eyebrow: "Autora y Fundadora",
    role: "Fundadora y CEO, Aviah Financial",
    bioTitle: "Trayectoria",
    articles: "Artículos de Escarling",
  },
  notFound: {
    title: "Esta página se movió — o nunca existió.",
    copy: "La dirección que seguiste no corresponde a ninguna página de este sitio.",
    cta: "Volver al inicio",
  },
};
